import { render } from "./ManageNotifications.vue?vue&type=template&id=20e217ed&scoped=true"
import script from "./ManageNotifications.vue?vue&type=script&lang=js"
export * from "./ManageNotifications.vue?vue&type=script&lang=js"

import "./ManageNotifications.vue?vue&type=style&index=0&id=20e217ed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e217ed"]])

export default __exports__